var moduleMap = {
	"./App": function() {
		return Promise.all([__webpack_require__.e(311), __webpack_require__.e(8046), __webpack_require__.e(3807), __webpack_require__.e(1098), __webpack_require__.e(8732), __webpack_require__.e(4386)]).then(function() { return function() { return (__webpack_require__(64386)); }; });
	},
	"./Share": function() {
		return Promise.all([__webpack_require__.e(311), __webpack_require__.e(8046), __webpack_require__.e(1098), __webpack_require__.e(7370)]).then(function() { return function() { return (__webpack_require__(77370)); }; });
	},
	"./ShareGroup": function() {
		return Promise.all([__webpack_require__.e(311), __webpack_require__.e(7069), __webpack_require__.e(1098), __webpack_require__.e(1130)]).then(function() { return function() { return (__webpack_require__(77237)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});